export default __webpack_public_path__ + "static/media/LI.29538666.webp";